import axios from 'axios';
import { API_ENDPOINTS } from '../config/api';

let isRefreshing = false;
let failedQueue: Array<{
  resolve: (value?: any) => void;
  reject: (error?: any) => void;
}> = [];

const processQueue = (error: any, token: string | null = null) => {
  failedQueue.forEach(({ resolve, reject }) => {
    if (error) {
      reject(error);
    } else {
      resolve(token);
    }
  });
  
  failedQueue = [];
};

export const setupAxiosInterceptors = () => {
  // Response interceptor to handle token refresh
  axios.interceptors.response.use(
    (response: any) => response,
    async (error: any) => {
      const originalRequest = error.config as any;

      if (error.response?.status === 401 && !originalRequest._retry) {
        if (isRefreshing) {
          // If already refreshing, queue the request
          return new Promise((resolve, reject) => {
            failedQueue.push({ resolve, reject });
          }).then(() => {
            return axios(originalRequest);
          }).catch((err) => {
            return Promise.reject(err);
          });
        }

        originalRequest._retry = true;
        isRefreshing = true;

        const refreshToken = localStorage.getItem('refreshToken');
        if (!refreshToken) {
          // No refresh token, redirect to login
          processQueue(error, null);
          isRefreshing = false;
          window.location.href = '/login';
          return Promise.reject(error);
        }

        try {
          const response = await axios.post(API_ENDPOINTS.auth.refresh, {
            refreshToken,
          });

          const { token, refreshToken: newRefreshToken } = response.data as any;
          
          // Update stored tokens
          localStorage.setItem('token', token);
          localStorage.setItem('refreshToken', newRefreshToken);
          
          // Update axios default header
          axios.defaults.headers.common['Authorization'] = `Bearer ${token}`;
          
          // Process queued requests
          processQueue(null, token);
          
          // Retry original request
          originalRequest.headers['Authorization'] = `Bearer ${token}`;
          return axios(originalRequest);
        } catch (refreshError) {
          // Refresh failed, clear auth state and redirect to login
          localStorage.removeItem('token');
          localStorage.removeItem('refreshToken');
          localStorage.removeItem('user');
          delete axios.defaults.headers.common['Authorization'];
          
          processQueue(refreshError, null);
          window.location.href = '/login';
          return Promise.reject(refreshError);
        } finally {
          isRefreshing = false;
        }
      }

      return Promise.reject(error);
    }
  );
};

